import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { withValue } from '@g4/automation-hooks';

import { Box, Media, Text } from '../../../../components/Boneyard';

const propTypes = {
  theme: PropTypes.object.isRequired,
  airportLabel: PropTypes.string.isRequired,
  airport: PropTypes.string,
  // Injected by Wrapper
  automationHook: PropTypes.string,
  namespace: PropTypes.oneOf(['origin', 'destination']).isRequired,
};

const FlightDetailsInfo = ({
  theme,
  airportLabel,
  airport,
  automationHook,
  namespace,
}) => {
  return (
    <Media>
      {mq => (
        <Box d="flex">
          <Text
            size={mq.lt('md') ? 14 : 19}
            weight={600}
            color={theme.colors.flights.flightDetails.text}
            automationHook={withValue(automationHook, `${namespace}-label`)}
          >
            {airportLabel}
          </Text>
          <Box pl={1}>
            <Text
              size={mq.lt('md') ? 14 : 19}
              weight={500}
              color={theme.colors.flights.flightDetails.text}
              automationHook={withValue(automationHook, `${namespace}-airport`)}
            >
              {airport}
            </Text>
          </Box>
        </Box>
      )}
    </Media>
  );
};
FlightDetailsInfo.propTypes = propTypes;
FlightDetailsInfo.displayName = 'FlightDetailsInfo';

export default withTheme(FlightDetailsInfo);
